module.exports = __webpack_public_path__ + "assets/005638ecb7c00f86ca92158ef5441d62.png";